import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Invoice, toInvoiceXml } from '../../dataObjects/Invoice';

export interface IUpdateInvoiceRequest extends IBaseRequest {
    INVOICE: Invoice;
}

export class UpdateInvoiceRequest extends BaseRequest implements IUpdateInvoiceRequest {
    public INVOICE: Invoice;

    constructor(server: string, session: string, invoice: Invoice) {
        super(server, session);
        this.INVOICE = invoice;
    }

    public toXml(): string {
        let parameters: string = super.toXml();
        parameters += toInvoiceXml(this.INVOICE);
        return super.wrapperXml('UpdateInvoice', parameters);
    }
}
